import { fade } from "../utils/color.js";
export default function createTooltipPalette(theme, current, base) {
    const fadedDark = fade(base.text[500], 0.85);
    return {
        tooltip: {
            light: {
                color: base.text[500],
                backgroundColor: base.background,
                borderColor: base.gray[200],
            },
            dark: {
                color: base.background,
                backgroundColor: fadedDark,
                borderColor: "transparent",
            },
        },
    };
}
//# sourceMappingURL=tooltip.js.map